export default {
  set: (state, items) => {
    state.items = (items && items.length > 0) ? items : []
  }
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/newsfeed/mutations.js